var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c('div',{staticClass:"header"},[(_vm.displayMenu)?_c('MainMenu'):_vm._e()],1),_c('Header'),_c('JobCareer'),_c('MainServices'),(_vm.displayMenu)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }